import type { BrandColors } from "../../../flyer-renderer/src/flyer/types";
import { CampoColorHex } from "./CampoColorHex";
import estilos from "./PaletaColores.module.css";

interface Props {
  colores: BrandColors;
  deshabilitado: boolean;
  onCambiar: (campo: keyof BrandColors, valor: string) => void;
}

const CAMPOS: [keyof BrandColors, string][] = [
  ["primary", "Primario"],
  ["secondary", "Secundario"],
  ["background", "Fondo"],
  ["text", "Texto"],
];

// Adaptado de PaletaColores.tsx del hermano "AI Video editor": ahi editaba
// `project.palette` via su propio PATCH /palette y boton "Guardar" propio.
// Aca no existe ese endpoint -- `brand.colors` es parte del mismo
// FlyerDocument que edita el resto del editor visual, asi que el componente
// queda controlado (sin estado propio ni llamada a la API): cada cambio
// actualiza el documento en memoria del padre y se persiste con el "Guardar"
// unico de EditorVisualFlyer.
export function PaletaColores({
  colores,
  deshabilitado,
  onCambiar,
}: Props): JSX.Element {
  return (
    <section className={estilos.tarjeta} aria-labelledby="titulo-paleta">
      <header className={estilos.cabecera}>
        <h3 id="titulo-paleta">Paleta de marca</h3>
        <p className={estilos.subtitulo}>
          Colores de referencia del flyer (los textos/formas pueden usarlos via{" "}
          <code>$brand.*</code> o tener su propio color).
        </p>
      </header>
      <div className={estilos.muestras}>
        {CAMPOS.map(([campo, etiqueta]) => (
          <CampoColorHex
            key={campo}
            id={`paleta-${campo}`}
            etiqueta={etiqueta}
            valor={colores[campo]}
            onChange={(valor) => onCambiar(campo, valor)}
            deshabilitado={deshabilitado}
          />
        ))}
      </div>
    </section>
  );
}
